import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-pipeline-status',
    templateUrl: './pipeline-status.component.html',
    styleUrls: ['./pipeline-status.component.scss'],
    standalone: false
})
export class PipelineStatusComponent implements OnInit {
	@Input() pipeline: any;
	@Input() pipelineStep: any;
	constructor() {}

	ngOnInit(): void {}

	pipelineToArray(object: { [key: string]: string }) {
		let arr = Object.keys(object).map(function (key, index) {
			return { label: object[key], value: index + 1 };
		});
		return arr;
	}

	trackByFn(index: number) {
		return index;
	}
}
